export default __webpack_public_path__ + "static/media/ios-mobile-download-btn.c552acce.svg";